import api from '@/features/api/axios';
import { Signer } from '@/features/application/types/signers';
import { getRecaptchaHeaders } from '@/features/application/utils/recaptcha-token.utils';

const getSigners = async (
  userShortId: string,
  mappingShortId: string,
  crmId: string
): Promise<Signer[]> => {
  const { data } = await api.get(
    `/api/users/${userShortId}/mappings/${mappingShortId}/records/${crmId}/signers`
  );
  return data;
};

const addSigner = async (
  userShortId: string,
  mappingShortId: string,
  recordId: string,
  email: string,
  index: number
): Promise<Signer> => {
  const { data } = await api.post(
    `/api/users/${userShortId}/mappings/${mappingShortId}/records/${recordId}/signers`,
    {
      email,
      index,
    },
    { headers: await getRecaptchaHeaders('add_signer') }
  );
  return data;
};

const updateSigner = async (
  userShortId: string,
  mappingShortId: string,
  recordId: string,
  signerId: string,
  email: string
): Promise<Signer> => {
  const { data } = await api.put(
    `/api/users/${userShortId}/mappings/${mappingShortId}/records/${recordId}/signers/${signerId}`,
    { email },
    { headers: await getRecaptchaHeaders('update_signer') }
  );
  return data;
};

const deleteSigner = async (
  userShortId: string,
  mappingShortId: string,
  recordId: string,
  signerId: string
): Promise<void> => {
  await api.delete(
    `/api/users/${userShortId}/mappings/${mappingShortId}/records/${recordId}/signers/${signerId}`,
    { headers: await getRecaptchaHeaders('delete_signer') }
  );
};

const notifyAdditionalSigners = async (
  userShortId: string,
  mappingShortId: string,
  crmId: string,
  emails: string[]
): Promise<{ message: string; debugId: string }> => {
  // Use crmId as the recordId in the URL path (they are the same for all CRM providers)
  const { data } = await api.post(
    `/api/email/notify-additional-signers/${userShortId}/${mappingShortId}/${crmId}`,
    {
      crmId,
      emails,
    },
    { headers: await getRecaptchaHeaders('notify_additional_signers') }
  );
  return data;
};

export const signerApi = {
  getSigners,
  addSigner,
  updateSigner,
  deleteSigner,
  notifyAdditionalSigners,
};
